import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader, SIZE } from "baseui/modal";
import { FormattedMessage } from "react-intl";


const RemoveItemDialog = ({ isOpen, setIsOpen, onOk, objectDescription }) => {
    return (
        <Modal
            onClose={() => setIsOpen(false)}
            closeable
            isOpen={isOpen}
            animate
            autoFocus
            size={SIZE.default}
            role='dialog'
        >
            <ModalHeader><FormattedMessage id='Dashboard.RemoveItemDialogTitle' defaultMessage='Remove from Dashboard?' /></ModalHeader>
            <ModalBody>
                <FormattedMessage id='Dashboard.RemoveItemDialogText' defaultMessage='Do you really want to remove {objectDescription} from this dashboard?'
                    values={
                        { objectDescription: <b>{objectDescription}</b> }
                    } />
            </ModalBody>
            <ModalFooter>
                <ModalButton kind='tertiary' onClick={() => setIsOpen(false)}>
                    <FormattedMessage id='cancel' defaultMessage='Cancel' />
                </ModalButton>
                <ModalButton onClick={(e) => { e.preventDefault(); onOk(e); }}><FormattedMessage id='ok' defaultMessage='Ok' /></ModalButton>
            </ModalFooter>
        </Modal>
    );
}

export default RemoveItemDialog